import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import AppBar from "./../../components/DefaultAppBar";
import ProfileHeader from "./ProfileHeader";

export const route = "/profile/contact";

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(2),
  },
  subtitle1: {
    marginTop: theme.spacing(2.5),
    fontWeight: "bold",
    // listStyleType: "disc"
  },
  content: {
    marginTop: theme.spacing(0.4),
  },
}));

function ContactContainer() {
  const classes = useStyles();
  const intl = useIntl();
  const currentEstate = useSelector(({ estates }) => estates.currentEstate);
  const formatMessage = intl.formatMessage;

  return (
    <div>
      <AppBar position="static">
        <LocationFilterToolbar noTicketFilter />
      </AppBar>

      <ProfileHeader estate={currentEstate} />

      <Typography variant="h6" align="center" className={classes.title}>
        {formatMessage({ id: "profile.contact.title.subtitle" })}
      </Typography>

      <ul>
        <li>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {formatMessage({ id: "profile.contact.developer.label" })}
          </Typography>

          <Typography component="p" className={classes.content}>
            {`${formatMessage({
              id: "profile.contact.developer.content",
            })}: `}
            <a href="mailto:hello@hausify.de">hello@hausify.de</a>
          </Typography>
        </li>
        <li>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {formatMessage({ id: "profile.contact.hausify.label" })}
          </Typography>

          <Typography component="p" className={classes.content}>
            {`${formatMessage({ id: "profile.contact.hausify.content" })}: `}
            <a href="https://www.hausify.de/impressum">
              https://www.hausify.de/impressum
            </a>
            {/* Link zu unserer Webpr&auml;senz:  */}
          </Typography>
        </li>
        <li>
          <Typography variant="subtitle1" className={classes.subtitle1}>
            {formatMessage({ id: "profile.contact.phone.label" })}
          </Typography>

          <Typography component="p" className={classes.content}>
            {formatMessage({ id: "profile.contact.phone.content" })}
          </Typography>
        </li>
      </ul>
    </div>
  );
}

ContactContainer.route = route;

export default ContactContainer;
